import { PostValidationErrorMessage } from '~/constants';
import { getDateString } from '~/server/formatters';
import { PostEntity } from './PostEntity';

export const getPostValidationMessage = ({ post, userNeedsApproval }) => {
  const validationError = PostEntity.validatePost(post);
  if (!validationError) return null;

  const baseMessageSuffix = `before you ${
    userNeedsApproval ? 'request approval for' : 'schedule'
  } this post`;
  const errorMessage = PostValidationErrorMessage[validationError];
  if (!errorMessage) {
    return validationError;
  }
  return `${errorMessage} ${baseMessageSuffix}`;
};

export const getPostActionString = ({
  post,
  profileTimezone,
  twentyFourHourTime,
}) => {
  const isPastDue = PostEntity.isPastDue(post);
  const isDraft = PostEntity.isDraft(post);
  const dueAt = PostEntity.getDueAt(post);
  if (dueAt) {
    const dateString = getDateString(post.due_at, profileTimezone, {
      isPastDue,
      twentyFourHourTime,
    });
    return `${isDraft ? 'Draft' : 'Post'} scheduled for ${dateString}.`;
  }
  return null;
};
